/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Delete_TitleInputs */

const en_us2_body_assessment_delete_title = /** @type {(inputs: Body_Assessment_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this assessment?`)
};

const pt_br2_body_assessment_delete_title = /** @type {(inputs: Body_Assessment_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar esta avaliação?`)
};

const es_419_body_assessment_delete_title = /** @type {(inputs: Body_Assessment_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar esta evaluación?`)
};

const pt_pt2_body_assessment_delete_title = /** @type {(inputs: Body_Assessment_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar esta avaliação?`)
};

const fr_fr2_body_assessment_delete_title = /** @type {(inputs: Body_Assessment_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cette évaluation ?`)
};

const de_de2_body_assessment_delete_title = /** @type {(inputs: Body_Assessment_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Messung löschen?`)
};

const it_it2_body_assessment_delete_title = /** @type {(inputs: Body_Assessment_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare questa valutazione?`)
};

/**
* | output |
* | --- |
* | "Delete this assessment?" |
*
* @param {Body_Assessment_Delete_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_delete_title = /** @type {((inputs?: Body_Assessment_Delete_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Delete_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_delete_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_delete_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_delete_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_delete_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_delete_title(inputs)
	return en_us2_body_assessment_delete_title(inputs)
});
export { body_assessment_delete_title as "body-assessment.delete_title" }